import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Navbar, Nav } from 'react-bootstrap';
import classNames from 'classnames';
import AppContext from 'context/Context';
import Logo from 'components/common/Logo';
import SearchBox from './SearchBox';
import NavbarTopDropDownMenus from './NavbarTopDropDownMenus';
import { navbarBreakPoint, topNavbarBreakpoint } from 'config';
//import autoCompleteInitialItem from 'data/autocomplete/autocomplete';
import TopNavRightSideNavItem from './TopNavRightSideNavItem';
import { useLocation } from 'react-router-dom';
import LogoNavbar from 'components/common/LogoNavbar';

import imageFile1 from 'assets/img/products/3-thumb.png';
import imageFile2 from 'assets/img/icons/zip.png';
import imageMember1 from 'assets/img/team/1.jpg';
import imageMember2 from 'assets/img/team/2.jpg';
import imageMember3 from 'assets/img/team/3.jpg';
import { searchTickets, ticketSearchByKeywords } from 'functions/ticket';
import SearchBoxTickets from './SearchBoxTickets';


const NavbarTop = () => {
  const {
    config: { showBurgerMenu, navbarPosition, navbarCollapsed },
    setConfig
  } = useContext(AppContext);

  const { pathname } = useLocation();
  const isChat = pathname.includes('chat');

  const [showDropShadow, setShowDropShadow] = useState(false);

  const handleBurgerMenu = () => {
    (navbarPosition === 'top' || navbarPosition === 'double-top') &&
      setConfig('navbarCollapsed', !navbarCollapsed);
    (navbarPosition === 'vertical' || navbarPosition === 'combo') &&
      setConfig('showBurgerMenu', !showBurgerMenu);
  };

  const setDropShadow = () => {
    const el = document.documentElement;
    if (el.scrollTop > 0) {
      setShowDropShadow(true);
    } else {
      setShowDropShadow(false);
    }
  };




  useEffect(() => {
    window.addEventListener('scroll', setDropShadow);
    return () => window.removeEventListener('scroll', setDropShadow);
  }, []);

  const burgerMenuRef = useRef();

  return (
    <Navbar
      className={classNames('navbar-glass fs--1 navbar-top sticky-kit', {
        // 'navbar-glass-shadow': showDropShadow
        'navbar-glass-shadow': showDropShadow && !isChat
      })}
      expand={
        navbarPosition === 'top' ||
        navbarPosition === 'combo' ||
        navbarPosition === 'double-top'
          ? topNavbarBreakpoint
          : true
      }
    >
      {navbarPosition === 'double-top' ? (
        <div className="w-100">
          <div className="d-flex flex-between-center">
            <NavbarTopElements
              navbarCollapsed={navbarCollapsed}
              navbarPosition={navbarPosition}
              handleBurgerMenu={handleBurgerMenu}
              burgerMenuRef={burgerMenuRef}
            />
          </div>
          <hr className="my-2 d-none d-lg-block" />
          <Navbar.Collapse in={navbarCollapsed} className="scrollbar py-2">
            <Nav navbar>
              <NavbarTopDropDownMenus />
            </Nav>
          </Navbar.Collapse>
        </div>
      ) : (
        <NavbarTopElements
          navbarCollapsed={navbarCollapsed}
          navbarPosition={navbarPosition}
          handleBurgerMenu={handleBurgerMenu}
          burgerMenuRef={burgerMenuRef}
        />
      )}
    </Navbar>
  );
};

const NavbarTopElements = ({
  navbarPosition,
  handleBurgerMenu,
  navbarCollapsed
}) => {
  const burgerMenuRef = useRef();




  // const [autoCompleteInitialItem,setAutoCompleteInitialItem] =useState([
  //   {
  //     id: 11,
  //     catagories: 'suggestedFilters',
  //     url: '/e-commerce/customers',
  //     key: 'tickets',
  //     text: 'All customers list',
  //     type: 'warning'
  //   },
   
  //   {
  //     id: 1,
  //     url: '/events/event-detail',
  //     breadCrumbTexts: ['Pages ', ' Events'],
  //     catagories: 'recentlyBrowsedItems'
  //   },
  //   {
  //     id: 2,
  //     url: '/e-commerce/customers',
  //     breadCrumbTexts: ['E-commerce ', ' Customers'],
  //     catagories: 'recentlyBrowsedItems'
  //   },
  //   {
  //     id: 3,
  //     catagories: 'suggestedFilters',
  //     url: '/e-commerce/customers',
  //     key: 'customers',
  //     text: 'All customers list',
  //     type: 'warning'
  //   },
  //   {
  //     id: 4,
  //     catagories: 'suggestedFilters',
  //     url: '/events/event-detail',
  //     key: 'events',
  //     text: 'Latest events in current month',
  //     type: 'success'
  //   },
  //   {
  //     id: 5,
  //     catagories: 'suggestedFilters',
  //     url: '/e-commerce/product/product-grid',
  //     key: 'products',
  //     text: 'Most popular products',
  //     type: 'info'
  //   },
  //   {
  //     id: 6,
  //     catagories: 'suggestionFiles',
  //     url: '#!',
  //     img: imageFile1,
  //     file: true,
  //     title: 'iPhone',
  //     imgAttrs: {
  //       class: 'border h-100 w-100 fit-cover rounded-3'
  //     },
  //     time: '<span class="fw-semi-bold">Antony</span><span class="fw-medium text-600 ms-2">27 Sep at 10:30 AM</span>'
  //   },
  //   {
  //     id: 7,
  //     catagories: 'suggestionFiles',
  //     url: '#!',
  //     img: imageFile2,
  //     file: true,
  //     title: 'Falcon v1.8.2',
  //     imgAttrs: {
  //       class: 'img-fluid'
  //     },
  //     time: '<span class="fw-semi-bold">John</span><span class="fw-medium text-600 ms-2">30 Sep at 12:30 PM</span>'
  //   },
  //   {
  //     id: 8,
  //     url: '/user/profile',
  //     catagories: 'suggestionMembers',
  //     icon: {
  //       img: imageMember2,
  //       size: 'l',
  //       status: 'status-online'
  //     },
  //     title: 'Anna Karinina',
  //     text: 'Technext Limited'
  //   },
  //   {
  //     id: 9,
  //     url: '/user/profile',
  //     catagories: 'suggestionMembers',
  //     icon: {
  //       img: imageMember1,
  //       size: 'l'
  //     },
  //     title: 'Antony Hopkins',
  //     text: 'Brain Trust'
  //   },
  //   {
  //     id: 10,
  //     url: '/user/profile',
  //     catagories: 'suggestionMembers',
  //     icon: {
  //       img: imageMember3,
  //       size: 'l'
  //     },
  //     title: 'Emma Watson',
  //     text: 'Google'
  //   }
  // ]);




  return (
    <>
      <Navbar.Toggle
        ref={burgerMenuRef}
        className={classNames('toggle-icon-wrapper me-md-3 me-2', {
          'd-lg-none':
            navbarPosition === 'top' || navbarPosition === 'double-top',
          [`d-${navbarBreakPoint}-none`]:
            navbarPosition === 'vertical' || navbarPosition === 'combo'
        })}
        as="div"
      >
        <button
          className="navbar-toggler-humburger-icon btn btn-link d-flex flex-center"
          onClick={handleBurgerMenu}
          id="burgerMenu"
        >
          <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span>
        </button>
      </Navbar.Toggle>

      <LogoNavbar at="navbar-top" width={40} id="topLogo" />

      {navbarPosition === 'top' || navbarPosition === 'combo' ? (
        <Navbar.Collapse
          in={navbarCollapsed}
          className="scrollbar pb-3 pb-lg-0"
        >
          <Nav navbar>
            <NavbarTopDropDownMenus />
          </Nav>
        </Navbar.Collapse>
      ) : (
        <Nav
          navbar
          className={`align-items-center d-none d-${topNavbarBreakpoint}-block`}
          as="ul"
        >
          <Nav.Item as="li">
            <SearchBoxTickets  />
        
          </Nav.Item>
        </Nav>
      )}
      <TopNavRightSideNavItem />
    </>
  );
};

NavbarTopElements.propTypes = {
  navbarPosition: PropTypes.string,
  handleBurgerMenu: PropTypes.func,
  navbarCollapsed: PropTypes.bool
};
export default NavbarTop;
